import { render, staticRenderFns } from "./what_is_study.vue?vue&type=template&id=48f903b3"
import script from "./what_is_study.vue?vue&type=script&lang=js"
export * from "./what_is_study.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports